// extracted by mini-css-extract-plugin
module.exports = {"chartContainer":"ring-chart_chartContainer_2HCoc","noData":"ring-chart_noData_2a-oP"};